import { getLink } from "../../../utils/utils";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Al la sudo sin direktas ŝipa ar’, <br/>
        Ĝis Bospor’ ĉirkaŭe sternas sin la mar’. <br/>
        Nek insulo, nek miraĝ’ sur blua ond’… <br/>
        Certe, «Estas multaj urboj en la mond’»
      </p>

      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf:</span> <br/>
        La sunsubiro, la tagfiniĝo, Odes’ angoras. <br/>
        Ja diris Puŝkin, ke iuj mortis, kaj iuj foras. <br/>
        Drinku ni pro odesanoj-geamikoj, <br/>
        Kiuj estas en kaj post la Atlantiko.
      </p>

      <p class="poem-block mb-3">
        Sed ni restas, ni elvivas en Odes’. <br/>
        Ni malsatas, frostotremas, - tamen, jes! <br/>
        Iu nin malamas arde, kun envi’. <br/>
        Ridas ni tra larmoj, tamen – ridas ni!
      </p>
      
      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf.</span>
      </p>

      <p class="poem-block mb-3">
        La sun’ leviĝos, la sun’ leviĝos en urb’ ĉemara. <br/>
        Revenos kantoj, revenos homoj al panjo kara. <br/>
        Longan nokton ni travivos kun honoro, <br/>
        Post tenebro devas veni la aŭroro.
      </p>
      
      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf.</span>
      </p>

    </div>
    `
  )
}

const itemName = {
  esp: 'Kanto pri Odeso de 90aj jaroj'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: `
      La aŭtoro nekonata, <br/>
      Teksto: T. Auderskaja
    `
  }
}

export default item;